
import {Vue, Component, Prop} from 'vue-property-decorator';

@Component({})
export default class SayfaAciklama extends Vue {

  @Prop() baslik!:string
  @Prop() altBaslik!:string
}
